import React, { useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../lib/firebase";
import { updateProfile } from "firebase/auth";

//const RequireUser: React.FC<RequireUserProps> = ({ children }) => {

async function UpdateUserProfileName(userProfileName: string) {
  auth.onAuthStateChanged(async (user) => {
    if (user) {
      //console.log("UserInformation update profile before useAuthState");
      //const [user, loading] = useAuthState(auth);
      //const [user, setUser] = useState();
      console.log("UserInformation update profile name and user = ", user);
      //if (loading) return <div>Loading...</div>;
      console.log("UserInformation update profile before updateProfile");
      await updateProfile(user, { displayName: userProfileName }).catch((err) =>
        console.log(" displayName err = ", err)
      );
      console.log("UserInformation update profile after useAuthState");
    }
  });
}
export default UpdateUserProfileName;
